/* Siplo 2026 redesign: menu drawer, AJAX add-to-cart, shop filter/sort, contact validation. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---- Menu drawer ---- */
  var drawer = document.querySelector('[data-sp-drawer]');
  var opener = document.querySelector('[data-sp-menu-open]');
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    opener.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    opener.focus();
  }
  if (drawer && opener) {
    opener.addEventListener('click', function () {
      drawer.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var first = drawer.querySelector('.sp-drawer__list a');
      if (first) first.focus();
    });
    drawer.querySelectorAll('[data-sp-menu-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---- Cart count ---- */
  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-sp-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        var link = document.querySelector('[data-sp-cart-link]');
        if (link) link.setAttribute('aria-label', 'Cart' + (cart.item_count ? ', ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') : ''));
        return cart;
      });
  }

  /* ---- Add to cart (shop cards + PDP) ---- */
  function announce(btn, msg) {
    var region = document.querySelector('[data-sp-results], [data-sp-cart-status]');
    if (region) region.textContent = msg;
  }
  function addToCart(btn, variantId) {
    var label = btn.querySelector('[data-sp-add-label]');
    var original = btn.getAttribute('data-label') || (label && label.textContent);
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (label) label.textContent = 'ADDED TO CART';
        announce(btn, 'Added to cart.');
        return refreshCount();
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        if (label) label.textContent = (err && err.status === 422) ? 'SOLD OUT' : 'TRY AGAIN';
        announce(btn, (err && err.description) || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = original; }, 2400);
      });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-sp-add]');
    if (!btn || btn.disabled || btn.type === 'submit') return;
    e.preventDefault();
    addToCart(btn, btn.getAttribute('data-sp-add'));
  });
  document.querySelectorAll('[data-sp-product-form]').forEach(function (form) {
    var select = form.querySelector('[data-sp-variant]');
    var idInput = form.querySelector('input[name="id"]');
    if (select) select.addEventListener('change', function () {
      idInput.value = select.value;
      var price = document.querySelector('[data-sp-price]');
      var opt = select.options[select.selectedIndex];
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    });
    form.addEventListener('submit', function (e) {
      var btn = form.querySelector('button[data-sp-add]');
      if (!btn) return;
      e.preventDefault();
      addToCart(btn, idInput.value);
    });
  });

  /* ---- Shop filter & sort ---- */
  var shop = document.querySelector('[data-sp-shop]');
  if (shop) {
    var toggle = shop.querySelector('[data-sp-filter-toggle]');
    var panel = shop.querySelector('[data-sp-filters]');
    var grid = shop.querySelector('[data-sp-grid]');
    var countEl = shop.querySelector('[data-sp-count]');
    var results = shop.querySelector('[data-sp-results]');
    var clear = shop.querySelector('[data-sp-clear]');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-sp-card]')) : [];
    var original = cards.slice();
    toggle && toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
    function apply() {
      var sort = (panel.querySelector('input[name="sp-sort"]:checked') || {}).value || 'featured';
      var bases = Array.prototype.map.call(panel.querySelectorAll('input[name="sp-base"]:checked'), function (i) { return i.value; });
      var list = original.slice();
      if (sort === 'az') list.sort(function (a, b) { return a.dataset.title.localeCompare(b.dataset.title); });
      if (sort === 'price-asc') list.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      if (sort === 'price-desc') list.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      var visible = 0;
      list.forEach(function (c) {
        var show = !bases.length || bases.indexOf(c.dataset.base) > -1;
        c.hidden = !show;
        if (show) visible++;
        grid.appendChild(c);
      });
      countEl.textContent = visible;
      results.textContent = 'Showing ' + visible + ' of ' + original.length + ' products';
      clear.hidden = !(bases.length || sort !== 'featured');
    }
    panel && panel.addEventListener('change', apply);
    clear && clear.addEventListener('click', function () {
      panel.querySelectorAll('input[name="sp-base"]').forEach(function (i) { i.checked = false; });
      var f = panel.querySelector('input[name="sp-sort"][value="featured"]');
      if (f) f.checked = true;
      apply();
    });
  }

  /* ---- Contact validation (server still validates) ---- */
  var cform = document.querySelector('[data-sp-contact]');
  if (cform) {
    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var phoneRe = /^[+()\-.\s\d]{7,20}$/;
    function setErr(input, bad) {
      var err = document.getElementById(input.id + '-err');
      input.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (err) {
        err.hidden = !bad;
        if (bad) input.setAttribute('aria-describedby', err.id);
      }
      return bad;
    }
    cform.addEventListener('submit', function (e) {
      var firstBad = null;
      cform.querySelectorAll('input, select, textarea').forEach(function (el) {
        if (!el.id) return;
        var v = el.value.trim();
        var bad = false;
        if (el.required && !v) bad = true;
        else if (el.type === 'email' && v && !emailRe.test(v)) bad = true;
        else if (el.hasAttribute('data-sp-phone') && v && !phoneRe.test(v)) bad = true;
        if (document.getElementById(el.id + '-err')) setErr(el, bad);
        if (bad && !firstBad) firstBad = el;
      });
      if (firstBad) { e.preventDefault(); firstBad.focus(); return; }
      var btn = cform.querySelector('[data-sp-submit]');
      if (btn) { btn.disabled = true; var l = btn.querySelector('[data-sp-submit-label]'); if (l) l.textContent = 'SENDING…'; }
    });
    var ok = cform.querySelector('.sp-contact__status');
    if (ok) ok.focus();
  }
})();
